import { FileViewerType } from '../model/types';

export const getFileViewerType = (extension: string): FileViewerType => {
    switch (extension?.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'svg':
            return 'image';
        case 'mp4':
        case 'mov':
        case 'webm':
        case 'avi':
        case 'mkv':
            return 'video';
        case 'pdf':
            return 'pdf';
        default:
            return 'other';
    }
};
